<template>
  <div class="rs-card__body">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsCardBody',
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-card__body{
  flex: 1 1 auto;
  padding: 1rem;
  p{
    &:last-of-type{
      margin-bottom: 0;
    }
  }
}
</style>
